// Custom event fired after any same-tab localStorage mutation made through this
// util. The native `storage` event only fires in OTHER tabs, so consumers that
// need to react to same-tab writes (e.g. AuthProvider deciding whether to mount
// PropelAuth) subscribe to this event instead.
export const LOCAL_STORAGE_EVENT = 'local-storage';

// Keys with this prefix record what this browser has already shown a user
// (e.g. an onboarding tour), not session data, so clear() keeps them. Otherwise
// every sign-out or expired token would replay first-time tours.
export const ONBOARDING_KEY_PREFIX = 'onboarding:';

function notifyLocalStorageChange() {
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event(LOCAL_STORAGE_EVENT));
	}
}

function getOnboardingEntries() {
	const entries: [string, string][] = [];

	for (let index = 0; index < localStorage.length; index++) {
		const key = localStorage.key(index);
		const value = key ? localStorage.getItem(key) : null;

		if (key?.startsWith(ONBOARDING_KEY_PREFIX) && value !== null) {
			entries.push([key, value]);
		}
	}

	return entries;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class LocalStorage {
	public static getFromLocalStorage(name: string) {
		return localStorage.getItem(name);
	}

	public static removeFromLocalStorage(name: string) {
		localStorage.removeItem(name);
		notifyLocalStorageChange();
	}

	public static setItemInLocalStorage(name: string, value: string) {
		localStorage.setItem(name, value);
		notifyLocalStorageChange();
	}

	public static clear() {
		const onboardingEntries = getOnboardingEntries();

		localStorage.clear();
		onboardingEntries.forEach(([key, value]) =>
			localStorage.setItem(key, value),
		);
		notifyLocalStorageChange();
	}
}
